import { render } from "./BaseDialog.vue?vue&type=template&id=565cc647"
import script from "./BaseDialog?vue&type=script&lang=js"
export * from "./BaseDialog?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__